import './press-registration.scss';

/**
 * version    1.0
 * class      <type> (press registration)
 * classdesc  Component that manage the press registration form
 */
export class PressRegistrationExtended {
  constructor() {
    document.querySelectorAll('.file-upload-container').forEach((container) => {
      this.initUploader(container);
    });

    document.querySelectorAll('input[data-in-corso]').forEach((checkbox) => {
      this.initInCorso(checkbox);
    });
  }

  initInCorso(checkbox) {
    const targetId = checkbox.dataset.controls;
    if (!targetId) return;

    const dataFineInput = document.getElementById(targetId);
    if (!dataFineInput) return;

    const toggle = () => {
      const fp = dataFineInput._flatpickr;
      if (checkbox.checked) {
        if (fp) {
          fp.clear();
          fp.set('clickOpens', false);
        }
        dataFineInput.disabled = true;
      } else {
        dataFineInput.disabled = false;
        if (fp) fp.set('clickOpens', true);
      }
    };

    checkbox.addEventListener('change', toggle);
    toggle(); // stato iniziale
  }

  initUploader(container) {
    const input = container.querySelector('.file-input');
    const label = container.querySelector('.file-upload-label');

    if (!input || !label) return;

    const fileInfo = document.createElement('div');
    fileInfo.className = 'file-upload-info d-none';
    fileInfo.innerHTML = `
      <span class="file-upload-name"></span>
      <button type="button" class="file-upload-remove" aria-label="Rimuovi file">
        <svg role="img" class="svg-icon svg-icon--close"><use xlink:href="#sprite-close"></use></svg>
      </button>
    `;
    container.appendChild(fileInfo);

    const nameEl = fileInfo.querySelector('.file-upload-name');

    input.addEventListener('change', () => {
      if (input.files && input.files[0]) {
        nameEl.textContent = input.files[0].name;
        label.classList.add('d-none');
        fileInfo.classList.remove('d-none');
      }
    });

    fileInfo.querySelector('.file-upload-remove').addEventListener('click', () => {
      const inp = input;
      inp.value = '';
      fileInfo.classList.add('d-none');
      label.classList.remove('d-none');
    });
  }
}
